module.exports = __webpack_public_path__ + "media/images/emblems/Semsales-coat_of_arms-d26b1b3b0f9ae2fa76f71619147736aa.svg";